import React from 'react';

const CheckoutContext = React.createContext({ swish: false, setSwish: () => {}, isCoursePayment: true });
export default CheckoutContext;
